import { TableSortLabel } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import { CollectionOrderDirection, ResourceType } from 'json-api-hooks';
import React from 'react';

import { Column } from './index';

type HeadCellProps<T extends ResourceType> = Column<T> & {
  currentSorting?: CollectionOrderDirection;
  onSortChange?: (value: string, direction: CollectionOrderDirection | undefined) => void;
};

const HeadCell = <T extends ResourceType>({
  attribute,
  currentSorting,
  label,
  onSortChange,
  sortable,
}: HeadCellProps<T>) => {
  if (!sortable || !onSortChange) {
    return <TableCell>{label}</TableCell>;
  }

  const handleClick = () => {
    if (!currentSorting) {
      onSortChange(attribute, CollectionOrderDirection.Asc);
    } else if (currentSorting === CollectionOrderDirection.Asc) {
      onSortChange(attribute, CollectionOrderDirection.Desc);
    } else {
      onSortChange(attribute, undefined);
    }
  };

  return (
    <TableCell>
      <TableSortLabel active={!!currentSorting} direction={currentSorting} onClick={handleClick}>
        {label}
      </TableSortLabel>
    </TableCell>
  );
};
export default HeadCell;
